"use strict";
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
var Vector2_1 = require('gdx-ai/lib/math/Vector2');
var Vector3_1 = require('gdx-ai/lib/math/Vector3');
var SteeringAcceleration_1 = require('gdx-ai/lib/steer/SteeringAcceleration');
var MoveCommand_1 = require('./commands/MoveCommand');
var SteeringActor_1 = require('./SteeringActor');
var JumpState;
(function (JumpState) {
    JumpState[JumpState["IDLE"] = 0] = "IDLE";
    JumpState[JumpState["WAITING"] = 1] = "WAITING";
    JumpState[JumpState["JUMPED"] = 2] = "JUMPED";
})(JumpState || (JumpState = {}));
var steeringOutput = new SteeringAcceleration_1.default(new Vector3_1.default());
var tv0 = vec3.create();
var _v2 = new Vector2_1.default();
var CommandControl = (function () {
    function CommandControl(game, object) {
        this.game = game;
        this.object = object;
        this.independentFacing = false;
        this.steeringActor = new SteeringActor_1.default(object);
    }
    CommandControl.prototype.move = function (path) {
        this.command = new MoveCommand_1.default(this.steeringActor, path.map(function (node) { return new Vector3_1.default(node); }), this.game.objects.map(function (object) { return object.commandControl.steeringActor; }), this.game.getTickID, this.game.raycastSolidVoxels);
        return this.command.done;
    };
    CommandControl.prototype.jump = function () {
        return new Promise(function (resolve, reject) {
            setTimeout(resolve, 1000);
        });
    };
    CommandControl.prototype.stop = function () {
        this.command = null;
    };
    CommandControl.prototype.update = function (delta) {
        if (!this.command)
            return;
        var steeringBehavior = this.command.getSteeringBehavior();
        if (steeringBehavior) {
            // Calculate steering acceleration
            steeringBehavior.calculateSteering(steeringOutput);
            /*
             * Here you might want to add a motor control layer filtering steering accelerations.
             *
             * For instance, a car in a driving game has physical constraints on its movement: it cannot turn while stationary; the
             * faster it moves, the slower it can turn (without going into a skid); it can brake much more quickly than it can
             * accelerate; and it only moves in the direction it is facing (ignoring power slides).
             */
            // Apply steering acceleration
            this.applySteering(steeringOutput, delta);
        }
        // this.updatePhysics(delta);
        // this.mesh.position.set(this.position.x, this.position.y, this.position.z);
        if (!this.command.update(delta)) {
            this.command = null;
        }
    };
    CommandControl.prototype.isIndependentFacing = function () {
        return this.independentFacing;
    };
    CommandControl.prototype.setIndependentFacing = function (independentFacing) {
        this.independentFacing = independentFacing;
    };
    CommandControl.prototype.applySteering = function (steering, deltaTime) {
        // Update position and linear velocity
        if (!steeringOutput.linear.isZero()) {
            // this method internally scales the force by deltaTime
            this.object.physics.applyForce(vec3.scale(tv0, steeringOutput.linear.data, deltaTime));
        }
        var maxAngularSpeed = this.steeringActor.getMaxAngularSpeed();
        var angularVelocity = this.steeringActor.getAngularVelocity();
        var anyAngularAccelerations = false;
        // Update orientation and angular velocity
        if (this.isIndependentFacing()) {
            // this.mesh.rotateY(this.angularVelocity * deltaTime);
            this.object.rotateY(angularVelocity * deltaTime);
            if (steeringOutput.angular !== 0) {
                // this method internally scales the torque by deltaTime
                // this.body.applyTorque(tmpVector3.set(0, steeringOutput.angular, 0));
                angularVelocity += steeringOutput.angular * deltaTime;
                anyAngularAccelerations = true;
            }
        }
        else {
            // If we haven't got any velocity, then we can do nothing.
            var linVel = this.steeringActor.getLinearVelocity();
            if (linVel.sqrLen() >= this.steeringActor.getZeroLinearSpeedThreshold()) {
                var newOrientation = this.steeringActor.vectorToAngle(linVel);
                var deltaDirectionY = newOrientation - this.object.getYaw();
                this.object.rotateY(deltaDirectionY);
                angularVelocity = deltaDirectionY / deltaTime;
                anyAngularAccelerations = true;
            }
        }
        if (anyAngularAccelerations) {
            if (angularVelocity > maxAngularSpeed) {
                this.steeringActor.setAngularVelocity(maxAngularSpeed);
            }
            else if (angularVelocity < -maxAngularSpeed) {
                this.steeringActor.setAngularVelocity(-maxAngularSpeed);
            }
            else {
                this.steeringActor.setAngularVelocity(angularVelocity);
            }
        }
    };
    return CommandControl;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CommandControl;
//# sourceMappingURL=CommandControl.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/controls/CommandControl/CommandControl.js
 ** module id = 925
 ** module chunks = 0
 **/